{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "早上好",
        "afternoon": "下午好",
        "evening": "晚上好"
      },
      "header": {
        "fallbackUser": "用户",
        "facility": "机构 {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} 项重要检验结果需要确认",
        "message_other": "{{count}} 项重要检验结果需要确认",
        "reviewNow": "立即查看"
      },
      "sections": {
        "overview": "概览",
        "tasks": "任务",
        "myPatients": "我的患者",
        "recentActivity": "最近活动",
        "quickActions": "快捷操作"
      },
      "stats": {
        "activeEncounters": "进行中的就诊",
        "pendingOrders": "待处理医嘱",
        "resultsToReview": "待审阅结果",
        "criticalAlerts": "重要警报"
      },
      "tasks": {
        "unsignedNotes": "未签名病历",
        "criticalResultsPending": "待处理的重要结果",
        "cosignaturesNeeded": "需要会签",
        "ordersToReview": "待审核医嘱",
        "activeMedications": "活动用药",
        "admissionsPending": "待入院",
        "ordersToVerify": "待药师核对的医嘱",
        "controlledSubstanceReviews": "管制药品复核",
        "systemAlerts": "系统警报",
        "systemStatus": "系统状态"
      },
      "systemStatusValue": {
        "healthy": "正常"
      },
      "empty": {
        "noPatients": "尚未分配在管患者。",
        "noTasks": "没有适用此角色的任务。",
        "noRecentEncounters": "没有最近的就诊记录。"
      },
      "quickActions": {
        "findPatient": {
          "label": "查找患者",
          "description": "搜索病历"
        },
        "registerPatient": {
          "label": "登记患者",
          "description": "新增患者"
        },
        "viewCensus": {
          "label": "查看在院名册",
          "description": "进行中的就诊"
        },
        "reports": {
          "label": "报表",
          "description": "查看分析"
        }
      },
      "viewAll": "查看全部",
      "bedLabel": "床位 {{n}}",
      "admittedLabel": "入院 {{date}}",
      "fallback": {
        "unknownPatient": "未知患者",
        "unknownType": "未知"
      },
      "acuity": {
        "1": "复苏",
        "2": "紧急",
        "3": "次紧急",
        "4": "较缓和",
        "5": "非紧急"
      },
      "encounterType": {
        "emergency": "急诊",
        "inpatient": "住院",
        "outpatient": "门诊",
        "observation": "留观"
      },
      "encounterStatus": {
        "active": "进行中",
        "completed": "已完成",
        "discharged": "已出院",
        "cancelled": "已取消",
        "pending": "待处理"
      }
    },
    "qualityMeasures": {
      "title": "质量指标",
      "subtitle": "跟踪临床质量指标和监管合规情况",
      "refresh": "刷新",
      "allTypesLabel": "全部类型",
      "allFacilitiesLabel": "全部机构",
      "targetPrefix": "目标:{{value}} {{unit}}",
      "updatedPrefix": "更新于:{{value}}",
      "measureType": {
        "process": "流程",
        "outcome": "结果",
        "structure": "结构"
      },
      "summary": {
        "totalMeasures": "指标总数",
        "meetingTarget": "达成目标",
        "belowTarget": "未达目标"
      },
      "toasts": {
        "refreshSuccess": "指标已刷新"
      },
      "results": {
        "title": "已记录结果",
        "period": "报告期",
        "facility": "机构",
        "denominator": "分母",
        "numerator": "分子",
        "exclusions": "排除",
        "rate": "比率",
        "source": "来源",
        "calculated": "计算时间",
        "empty": "本期该指标暂无已记录结果。",
        "loadError": "无法加载已记录结果。",
        "allFacilities": "全部机构",
        "record": "记录结果"
      },
      "sources": {
        "manual": "手工",
        "sql-template": "SQL 模板",
        "import": "导入"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA 报告已下载",
        "error": "QRDA 下载失败"
      },
      "record": {
        "title": "记录质量结果",
        "titleFor": "记录结果 — {{code}} {{name}}",
        "subtitle": "已记录的结果会显示在指标历史中，并纳入 QRDA III 类导出。重新记录同一报告期将替换原有行。",
        "back": "返回质量指标",
        "cancel": "取消",
        "save": "记录结果",
        "measureNotFound": "未找到指标。该指标可能已停用。",
        "fields": {
          "periodStart": "报告期开始",
          "periodEnd": "报告期结束",
          "facility": "机构",
          "allFacilities": "全部机构",
          "denominator": "分母",
          "numerator": "分子",
          "exclusions": "排除",
          "source": "计算来源",
          "completeness": "数据完整度",
          "completenessHint": "数据完整的合格记录占比，0 到 1。不明请留空。",
          "notes": "备注"
        },
        "errors": {
          "periodStartRequired": "报告期开始为必填项",
          "periodEndRequired": "报告期结束为必填项",
          "periodOrder": "报告期结束不得早于报告期开始",
          "countInvalid": "请输入 0 或更大的整数",
          "numeratorExceeds": "分子不得超过分母",
          "numeratorExceedsNet": "分子不得超过分母减去排除数",
          "sourceRequired": "计算来源为必填项",
          "completenessRange": "完整度须介于 0 到 1 之间"
        },
        "toast": {
          "success": "结果已记录",
          "error": "记录失败"
        }
      }
    },
    "analyticsDashboard": {
      "title": "分析仪表板",
      "subtitle": "医院运营指标与趋势",
      "refresh": "刷新",
      "changeVsPrevPeriod": "{{sign}}{{value}}% 较上期",
      "dateRange": {
        "today": "今日",
        "7d": "近7天",
        "30d": "近30天",
        "90d": "近90天"
      },
      "facility": {
        "all": "全部机构",
        "sgh": "SGH - 新加坡中央医院",
        "nuh": "NUH - 新加坡国立大学医院",
        "ttsh": "TTSH - 陈笃生医院"
      },
      "department": {
        "all": "全部科室",
        "er": "急诊科",
        "icu": "重症监护室",
        "medsurg": "内外科",
        "peds": "儿科",
        "maternity": "产科"
      },
      "widget": {
        "census": {
          "title": "当前在院人数"
        },
        "bedOccupancy": {
          "title": "床位占用率"
        },
        "avgLOS": {
          "title": "平均住院日"
        },
        "throughput": {
          "title": "就诊总数"
        },
        "readmission": {
          "title": "待处理医嘱"
        }
      },
      "unit": {
        "patients": "位患者",
        "days": "天",
        "encounters": "次就诊",
        "orders": "条医嘱"
      },
      "charts": {
        "admissionsVsDischarges": "入院与出院",
        "admissionsByDepartment": "按科室入院数",
        "encounterTypes": "就诊类型",
        "censusTrend": "在院人数趋势",
        "insufficientData": "图表数据不足",
        "insufficientTrendData": "趋势图数据不足"
      },
      "series": {
        "admissions": "入院",
        "discharges": "出院",
        "census": "在院人数"
      },
      "toasts": {
        "refreshSuccess": "仪表板已刷新"
      }
    },
    "reportRunner": {
      "title": "报表运行",
      "subtitle": "生成并导出临床、财务和运营报表",
      "scheduleButton": "计划报表",
      "searchPlaceholder": "搜索报表...",
      "allCategoriesLabel": "全部报表",
      "category": {
        "clinical": "临床",
        "financial": "财务",
        "operational": "运营",
        "quality": "质量"
      },
      "emptyState": {
        "title": "请选择一份报表开始",
        "subtitle": "请从左侧报表列表中选择"
      },
      "noResults": "没有符合筛选条件的报表",
      "parametersHeading": "参数",
      "selectOptionPlaceholder": "请选择...",
      "runButton": "运行报表",
      "runningReport": "正在运行报表...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "日期(机构本地时间)",
        "facilityTimeZone": "机构时区",
        "encounterDate": "日期(UTC)"
      },
      "resultSummary": {
        "rows": "共 {{total}} 行,显示 {{shown}} 行",
        "executed": "执行用时 {{ms}} 毫秒"
      },
      "toasts": {
        "success": "报表已完成,用时 {{executionTimeMs}} 毫秒,共 {{rowCount}} 行",
        "failed": "报表运行失败",
        "missingFields": "请填写必填项:{{missingFields}}",
        "exporting": "正在导出为 {{format}}...(占位符)",
        "scheduledPlaceholder": "计划报表设置(占位符)"
      }
    }
  }
}
